var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-content-header", { attrs: { item: _vm.item } }),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("page-content-creator", {
                    attrs: { itemid: _vm.itemid, pos: "top" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _vm.itemid
                    ? _c("node-element-local-tasks", {
                        attrs: { itemid: _vm.itemid },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.notpublished
                    ? _c("div", { staticClass: "messages warning" }, [
                        _vm._v("Not published"),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "page-body" },
        [
          _vm.hasBody
            ? _c("page-content-wysiwg-content", { attrs: { item: _vm.item } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass: "people-group-set",
          class: [_vm.selectedcolorThemeOption],
        },
        [
          _vm._l(_vm.filteredGroups, function (group, groupIndex) {
            return _c(
              "div",
              { key: groupIndex, staticClass: "people-group" },
              [
                _c(
                  "b-container",
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", [
                          _vm.getGroupTitle(group)
                            ? _c(
                                "div",
                                { staticClass: "people-group-category-header" },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _c("h2", [
                                      _vm._v(_vm._s(_vm.getGroupTitle(group))),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm.getGroupDescription(group)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "people-group-category-description",
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.getGroupDescription(group)
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", [
                          _c(
                            "div",
                            {
                              staticClass: "people-display",
                              class: `${
                                _vm.selectedlayoutStyle
                              } ${_vm.getGroupGridStyle(group)}`,
                            },
                            _vm._l(
                              _vm.getPeople(group),
                              function (person, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "speaker-item" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "profile-teaser" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "profile-image" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "image-container-outer",
                                                class: _vm.isRound(
                                                  _vm.selectedAspectRatio
                                                ),
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.setShowModal(
                                                      person,
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("AImage", {
                                                  attrs: {
                                                    img: _vm.getImage(person),
                                                    "placeholder-url": require("assets/image-placeholders/person-placeholder.svg"),
                                                    ratio:
                                                      _vm.selectedAspectRatio,
                                                    preset: "peoplegroupperson",
                                                    cover: "",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.layoutIsGrid(
                                          _vm.selectedlayoutStyle
                                        )
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "profile-content-container",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setShowModal(
                                                        person,
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm.getName(person)
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "profile-name",
                                                        },
                                                        [
                                                          _c("h3", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getName(
                                                                  person
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "profile-info",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "profile-position",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.getPosition(
                                                                  person
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.getOrganisation(
                                                        person
                                                      ) &&
                                                      _vm.getPosition(person)
                                                        ? _c("span", [
                                                            _vm._v(","),
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "profile-organisation",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.getOrganisation(
                                                                  person
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "profile-content-container",
                                                },
                                                [
                                                  _vm.getName(person)
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "profile-name",
                                                        },
                                                        [
                                                          _c("h3", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getName(
                                                                  person
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "profile-info",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "profile-position",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.getPosition(
                                                                  person
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.getOrganisation(
                                                        person
                                                      ) &&
                                                      _vm.getPosition(person)
                                                        ? _c("span", [
                                                            _vm._v(","),
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "profile-organisation",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.getOrganisation(
                                                                  person
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass:
                                                      "person-description",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        person.description
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.modalPerson
            ? _c("sp-people-group-modal", {
                attrs: { person: _vm.modalPerson },
                model: {
                  value: _vm.showModal,
                  callback: function ($$v) {
                    _vm.showModal = $$v
                  },
                  expression: "showModal",
                },
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("page-content-creator", {
                    attrs: { itemid: _vm.itemid, pos: "bottom" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }